import { createFileRoute } from "@tanstack/react-router";
import { SupporterListPage, modenmisupporterHead } from "@/pages/SupporterListPage";

export const Route = createFileRoute("/en/meet-a-mi-supporter")({
  head: () => modenmisupporterHead("en"),
  component: () => <SupporterListPage locale="en" />,
});
